export default {
  animals: [
    { name: 'alligator', cname: '鱷魚' },
    { name: 'alpaca', cname: '羊駝' },
    { name: 'anteater', cname: '食蟻獸' },
    { name: 'armadillo', cname: '犰狳' },
    { name: 'auroch', cname: '野牛' },
    { name: 'axolotl', cname: '蠑螈' },
    { name: 'badger', cname: '獾' },
    { name: 'bat', cname: '蝙蝠' },
    { name: 'beaver', cname: '海狸' },
    { name: 'buffalo', cname: '水牛' },
    { name: 'camel', cname: '駱駝' },
    { name: 'chameleon', cname: '變色龍' },
    { name: 'cheetah', cname: '獵豹' },
    { name: 'chipmunk', cname: '花栗鼠' },
    { name: 'chinchilla', cname: '栗鼠' },
    { name: 'chupacabra', cname: '卓柏卡布拉' },
    { name: 'cormorant', cname: '鸕鶿' },
    { name: 'coyote', cname: '狡狼' },
    { name: 'crow', cname: '烏鴉' },
    { name: 'dingo', cname: '澳洲野犬' },
    { name: 'dinosaur', cname: '恐龍' },
    { name: 'dolphin', cname: '海豚' },
    { name: 'duck', cname: '鴨鴨' },
    { name: 'elephant', cname: '象象' },
    { name: 'ferret', cname: '雪貂' },
    { name: 'fox', cname: '狐狸' },
    { name: 'frog', cname: '青蛙' },
    { name: 'giraffe', cname: '長頸鹿' },
    { name: 'gopher', cname: '地鼠' },
    { name: 'grizzly', cname: '灰熊' },
    { name: 'hedgehog', cname: '刺蝟' },
    { name: 'hippo', cname: '河馬' },
    { name: 'hyena', cname: '鬣狗' },
    { name: 'jackal', cname: '豺狼' },
    { name: 'ibex', cname: '山羊' },
    { name: 'ifrit', cname: '精靈' },
    { name: 'iguana', cname: '美洲鬣蜥' },
    { name: 'koala', cname: '無尾熊' },
    { name: 'kraken', cname: '海怪' },
    { name: 'lemur', cname: '狐猴' },
    { name: 'leopard', cname: '豹豹' },
    { name: 'liger', cname: '獅虎' },
    { name: 'llama', cname: '駱馬' },
    { name: 'manatee', cname: '海牛' },
    { name: 'mink', cname: '水貂' },
    { name: 'monkey', cname: '猴猴' },
    { name: 'narwhal', cname: '獨角鯨' },
    { name: 'nyan cat', cname: '彩虹貓' },
    { name: 'orangutan', cname: '紅毛猩猩' },
    { name: 'otter', cname: '水獺' },
    { name: 'panda', cname: '熊貓' },
    { name: 'penguin', cname: '企鵝' },
    { name: 'platypus', cname: '鴨嘴獸' },
    { name: 'python', cname: '蟒蛇' },
    { name: 'pumpkin (sic!)', cname: '南瓜（？' },
    { name: 'quagga', cname: '斑驢' },
    { name: 'rabbit', cname: '兔兔' },
    { name: 'raccoon', cname: '浣熊' },
    { name: 'rhino', cname: '犀牛' },
    { name: 'sheep', cname: '綿羊' },
    { name: 'shrew', cname: '鼩鼱' },
    { name: 'skunk', cname: '臭鼬' },
    { name: 'slow loris', cname: '懶猴' },
    { name: 'squirrel', cname: '松鼠' },
    { name: 'tiger', cname: '老虎' },
    { name: 'turtle', cname: '烏龜' },
    { name: 'walrus', cname: '海象' },
    { name: 'wolf', cname: '狼狼' },
    { name: 'wolverine', cname: '金剛狼' },
    { name: 'wombat', cname: '袋熊' },
    { name: 'puffer fish', cname: '河豚' },
    { name: 'porcupine', cname: '豪豬' },
  ],
  description:
    'Hi~ 歡迎來到我的小園地\n有什麼想說的話\n可以透過下方的小框框\n若要聯繫請附上聯絡資訊哦！',
};



// WEBPACK FOOTER //
// ./src/Components/Messenger/setting.js